import { useQuery } from '@apollo/client';
import { graphql } from '../../__generated__';

export const useDoctorDispenseSummaryModal = (customerID: string) => {
  const { data, error, loading } = useQuery(
    graphql(`
      query mhrDispense($customerID: String) {
        mhrDispenseHistory(customerId: $customerID) {
          html
          ok
          error
          documentId
          uniqueRepositoryId
        }
      }
    `),
    {
      variables: {
        customerID,
      },
    },
  );

  return {
    ok: data?.mhrDispenseHistory?.ok ?? false,
    loading,
    error: error ? 'Error loading medicare overview' : data?.mhrDispenseHistory?.error,
    html: data?.mhrDispenseHistory?.html,
    documentId: data?.mhrDispenseHistory?.documentId,
    uniqueRepositoryId: data?.mhrDispenseHistory?.uniqueRepositoryId,
  };
};
